const initialState = { totalProducts: 0, totalPrice: 0, cartProducts: [] };

export const cartReducer = (state = initialState, { type, payload }) => {
  let isFound = false;
  let newCartProducts = [];
  switch (type) {
    case "ADD_TO_CART":
      newCartProducts = state.cartProducts;
      for (let i = 0; i < newCartProducts.length; i++) {
        if (newCartProducts[i]._id === payload._id) {
          newCartProducts[i].count += 1;
          isFound = true;
          break;
        }
      }
      if (!isFound) {
        newCartProducts.push({ ...payload, count: 1 });
      }
      return {
        totalProducts: state.totalProducts + 1,
        totalPrice: state.totalPrice + payload.price,
        cartProducts: newCartProducts,
      };

    case "REMOVE_FROM_CART":
      state.cartProducts.forEach((product) => {
        if (product._id === payload._id) {
          if (product.count > 1) {
            newCartProducts.push({ ...product, count: product.count - 1 });
          }
        } else {
          newCartProducts.push(product);
        }
      });

      return {
        totalProducts: state.totalProducts - 1,
        totalPrice: state.totalPrice - payload.price,
        cartProducts: newCartProducts,
      };

    case "CLEAR_CART":
      return { totalProducts: 0, totalPrice: 0, cartProducts: [] };

    case "SET_CART":
      return { ...payload };

    default:
      return state;
  }
};
